<gsp-context-menu #sortContextMenu [items]="contextMenuItems" [menuClass]="'sort-menu-context'" (menuClosed)="onMenuClosed()"></gsp-context-menu>
